import React from 'react';
import meImg from '../assets/meHS.jpeg';
import useWindowSize from './useWindowSize';
import '../index.css';

export default function About() {
const isMobile = useWindowSize().isMobile;
const aboutStyle = {
    position: 'relative',           // Required so meImgStyle anchors to this container    
    display: 'flex',
    flexDirection: 'column',
    justifyContent: isMobile ? 'flexStart' : 'center',       // Centers text blocks vertically in the card
    alignItems: isMobile ? 'center' : 'stretch',
    
    
    
    /*height: '70vh',*/
    // Height configuration:
    height: 'auto',                               // Lets container grow with text
    minHeight: isMobile ? 'auto' : '420px',        // Preserves layout on desktop
    maxHeight: isMobile ? 'auto' : 'none',        // Prevents card from pushing off-screen on short phones
    overflowY: isMobile ? 'auto' : 'visible',     // Adds smooth vertical scrolling if text exceeds 80vh


    
    
    
    width: '100%',
    padding: isMobile ? '1.5rem 1rem' : '3rem 2.5rem',         // Inner padding for content
    boxSizing: 'border-box',
    overflow: isMobile ? 'visible' : 'hidden',             // Automatically clips the image corner to match container
    borderRadius: '16px',           // Or whatever your outer container radius is
    backgroundColor: 'rgba(18, 18, 18, 0.55)',
    backdropFilter: 'blur(16px) saturate(120%)',
    boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.5)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    WebkitMaskImage: 'linear-gradient(to bottom, black 80%, transparent 100%)',
    maskImage: 'linear-gradient(to bottom, black 80%, transparent 100%)',
  }

  const pStyleUpper = {
    fontSize: isMobile ? '.9em' : '1.3em',
    width: isMobile ? '100%' : 'calc(100% - 160px)',    // Constrains paragraph 1 so it won't touch the headshot
    margin: isMobile ? '3.5rem 0 1.5rem 0' : '0 0 1.5rem 0',         // Clean bottom gap between paragraphs
    lineHeight: '1.5',
    textShadow: '0 1px 3px rgba(0, 0, 0, 0.8)',
  }

  const pStyleLower = {
    fontSize: isMobile ? '.9em' : '1.3em',
    width: '100%',                  // Paragraph 2 spans full width under the headshot
    margin: 0,
    lineHeight: '1.5',
    textShadow: '0 1px 3px rgba(0, 0, 0, 0.8)',
  }

  const meImgStyle = {
    position: isMobile ? 'static' : 'absolute',
    /*top: isMobile ? '14vh' : 0,*/
    top:0,
    right: 0,
    width: isMobile ? '30%' : 'auto',
    height: isMobile ? '30%' : 'auto',
    maxHeight: isMobile ? 'none' : '20vh',
    margin: isMobile ? '0' : '0',
    borderRadius: isMobile ? '50%' : '0 16px 0 30%',
    objectFit: 'cover',
    borderTopRightRadius: '16px',    // Matches container top-right curve
    borderBottomLeftRadius: '30%',  // Your custom inner curve
    zIndex: 6,
  }

  return (
        <div className = 'About' style = {aboutStyle}>
            <img src = {meImg} style = {meImgStyle} alt = "Eric Sergio"/>
            <p className = 'aboutTxt' style = {pStyleUpper}>
                <span className = 'intro0'>My name is Eric Sergio, and I am a Bellevue College graduate (BAS in Software Development, Magna Cum Laude) 
                    based in the Greater Seattle area. I bring a unique combination of technical training and hands-on operational experience. Over years 
                    in the hospitality industry, I’ve managed high-volume bar operations, supplier relations, and weekly inventory tracking. To solve 
                    real-world operational bottlenecks, I built and actively maintain a custom full-stack inventory management system that runs our weekly 
                    ordering workflows.
                     </span>
            </p>
            <p className = 'aboutTxt' style = {pStyleLower}>
                <span className = "intro1">Whether writing software, managing inventory operations, designing digital apparel, or leading home construction 
                    and renovation projects, I approach every challenge with systematic problem-solving, attention to detail, and a focus on execution.
                    </span>
            </p>
            {/*<p style = {desktopID}>{isMobile} || {width} || {useWindowSize().height}</p>*/}
            </div>
    )
}